<template>
  <div class="wrapper">
    <div class="container text-center">
      <h3 class="title">Ready to stop wasting budget?</h3>
      <p class="sub-title">Join +28,113 sites that use ClickCease to save money on their Google Ads</p>
      <a :href="pricingCta ? pricingUrl : signupUrl" class="btn-orange" target="_blank" style="display: inline-block;">Start FREE trial</a>
    </div>
  </div>
</template>

<script>
import { AppConfig } from "@/config";

export default {
  name: "StartFreeTrial",
  props: {
    pricingCta: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return { 
      signupUrl: `${AppConfig.siteUrl}/signup.html`,
      pricingUrl: `${AppConfig.siteUrl}/pricing.html`,
    };
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: block;
  min-height: 400px;
  background: transparent linear-gradient(180deg, #FDFBFA 0%, #FBF5F3 72%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
}
.container {
  padding-top: 52px;
  padding-bottom: 80px;
}
.sub-title {
  margin-top: 12px;
  margin-bottom: 28px;
}
</style>